import { render, staticRenderFns } from "./PaperlitSecureParameters.vue?vue&type=template&id=e94842c6&scoped=true"
import script from "./PaperlitSecureParameters.vue?vue&type=script&lang=js"
export * from "./PaperlitSecureParameters.vue?vue&type=script&lang=js"
import style0 from "./PaperlitSecureParameters.vue?vue&type=style&index=0&id=e94842c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94842c6",
  null
  
)

export default component.exports